import type { LoaderFunctionArgs } from '@remix-run/node';
import invariant from 'tiny-invariant';
import { getPaintColours } from '@modules/project/api';

export const loader = async ({ request, context }: LoaderFunctionArgs) => {
    const url = new URL(request.url);
    const link = url.searchParams.get('link');
    if (!link) {
        invariant(link, 'link is required.');
    }

    return await getPaintColours({ ...context, link });
};

export const QUERY_PAINT_COLOURS = '/remix-api/paint-picker/get-paint-colours';
